
import { useProductContext } from "@/context/ProductContext";
import AddProductSheet from "../AddProductSheet";
import EditProductSheet from "../EditProductSheet";
import DeleteConfirmDialog from "../DeleteConfirmDialog";
import { useProducts } from "@/hooks/useProducts";

const ProductDialogs = () => {
  const {
    isAddSheetOpen,
    setIsAddSheetOpen,
    isEditSheetOpen,
    setIsEditSheetOpen,
    isDeleteDialogOpen,
    setIsDeleteDialogOpen,
    selectedProduct,
    setSelectedProduct
  } = useProductContext();

  const { handleAddProduct, handleUpdateProduct, handleConfirmDelete } = useProducts();

  return (
    <>
      <AddProductSheet
        isOpen={isAddSheetOpen}
        onClose={() => setIsAddSheetOpen(false)}
        onAdd={handleAddProduct}
      />

      {selectedProduct && (
        <EditProductSheet
          product={selectedProduct}
          isOpen={isEditSheetOpen}
          onClose={() => {
            setIsEditSheetOpen(false);
            setSelectedProduct(null);
          }}
          onSave={handleUpdateProduct}
        />
      )}

      <DeleteConfirmDialog
        isOpen={isDeleteDialogOpen}
        onClose={() => {
          setIsDeleteDialogOpen(false);
          setSelectedProduct(null);
        }}
        onConfirm={handleConfirmDelete}
        title="Supprimer le produit"
        description="Êtes-vous sûr de vouloir supprimer ce produit ? Cette action est irréversible."
      />
    </>
  );
};

export default ProductDialogs;
